import api from '../../api/rideInformation';
import { handleGuiVersionOutdated } from '@/common/guiVersionHandler';
import { withDesignSections } from '@/utils/rideDesigns';

/**
 * Saving how the trip page looks: the design to show and any design's own
 * settings (ride.presentation_settings, one section per design id). For every
 * design's editor -- the poster's is the first (PosterEditor) -- so none of it
 * is about one design.
 *
 * It goes through update_ride_information_api, the same route as the ride
 * settings form, because the route is partial: only the fields sent change,
 * and of presentation_settings only the sections sent.
 */

// Sends payload to the partial ride update route. Owner-only on the server.
// Resolves to whether it was saved.
async function saveRideFields({ rootState, dispatch }, rideId, payload) {
  const { apptoken } = rootState.appauth;
  let code;
  try {
    const response = await api.updateRideInformation(apptoken, rideId, payload);
    code = response.data && response.data.ServerMassageCode;
  } catch (error) {
    // A user who is not the ride owner gets a 500 with no body.
    console.warn('saving the ride presentation failed:', error);
    code = null;
  }
  if (code === 'gui_version_outdated') {
    handleGuiVersionOutdated({ dispatch, rideInformationId: rideId });
  }
  return code === 'secsses';
}

// The page's ride header with fields changed in place, so the page redraws
// without refetching the ride.
function patchRideHeader({ rootState, commit }, fields) {
  const header = rootState.ride.rideHeader;
  if (header && header.ride) {
    commit('setRideHeader', Object.assign({}, header, {
      ride: Object.assign({}, header.ride, fields),
    }));
  }
}

const actions = {
  // design: the design to show. sections: { <design id>: its settings, or
  // null to put it back to automatic }; the designs left out are kept.
  // Resolves to whether it was saved.
  async saveRidePresentation(context, { rideId, design, sections = {} }) {
    const payload = { presentation_design: design, presentation_settings: sections };
    if (!await saveRideFields(context, rideId, payload)) return false;
    const header = context.rootState.ride.rideHeader;
    patchRideHeader(context, {
      presentation_design: design,
      presentation_settings: withDesignSections(header && header.ride, sections),
    });
    return true;
  },
  // The trip page's background photo (top_page_image_url, the same one the
  // ride settings form uploads). Resolves to whether it was saved.
  async saveRideTopPageImage(context, { rideId, url }) {
    if (!await saveRideFields(context, rideId, { top_page_image_url: url })) return false;
    patchRideHeader(context, { top_page_image_url: url });
    return true;
  },
};

export default {
  actions,
};
